import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';

@Injectable({
    providedIn: 'root'
})
export class AssetsService {
    get assetsUrl(): string{
        return `${this.dataCollectorService.baseurl()}/assets`;
    }
    get organizationUrl(): string{
        return `${this.dataCollectorService.baseurl()}/organization/`;
    }
    get assetsApiUrls(): any{
        return {
            ppmUrl: `${this.dataCollectorService.baseurl()}/ppm`,
            dataUrl : `${this.dataCollectorService.baseurl()}/assets/filter`,
            columnUrl: `${this.dataCollectorService.baseurl()}/assets/meta`,
            filterUrl: `${this.dataCollectorService.baseurl()}/assets/meta/filter`,
            bulkActionUrl: `${this.dataCollectorService.baseurl()}/assets/bulk_action`,
            category: `${this.dataCollectorService.baseurl()}/assets/category`,
            noteAttachmentUrl: `${this.dataCollectorService.baseurl()}/note_attachment`,
            serviceContractUrl: `${this.dataCollectorService.baseurl()}/service_contract`,
            inspectionHistoryUrl: `${this.dataCollectorService.baseurl()}/assets/inspection_form`,
            exportAssetSubmission: `${this.dataCollectorService.baseurl()}/reports/assets/asset_submission`,
            templateUrl: `${this.dataCollectorService.baseurl()}/assets/template`,
            projectUrl: `${this.dataCollectorService.baseurl()}/projects`
        };
    }
    assetDetailsLoaded: Subject<boolean> = new Subject<boolean>();
    currentAssetDetails = new BehaviorSubject(null);

    constructor(private dataCollectorService: DataCollectorService) {
        this.assetDetailsLoaded.next(false);
     }

    getAssetUrl(assetId: string): string {
        return `${this.dataCollectorService.baseurl()}/assets/${assetId}`;
    }

    activationURl(assetId: string,activate: any): string{
        return `${this.dataCollectorService.baseurl()}/assets/${assetId}/activate?is_active=${!activate}`;
    }

    deleteURL(assetId: string): string{
        return `${this.dataCollectorService.baseurl()}/assets/${assetId}`;
    }

    getAssetHistoryUrl(assetId: string): string{
        return `${this.getAssetUrl(assetId)}/history`;
    }

    getPrintSharePdfUrl(assetId: string): string{
        return `${this.getAssetUrl(assetId)}/card`;
    }

    getAssetTemplates(): any{
        return this.dataCollectorService.getData(this.assetsApiUrls.templateUrl);
    }

    postAssetCardTemplate(assetId, payload): any{
        return this.dataCollectorService.postData(`${this.dataCollectorService.baseurl()}/assets/${assetId}/card`,payload);
    }

    updateAssetStatus(assetId, payload): any{
        return this.dataCollectorService.putData(`${this.dataCollectorService.baseurl()}/assets/${assetId}/status`,payload);
    }

    getAssetNotes(assetId: string): string {
        return `${this.dataCollectorService.baseurl()}/notes`;
    }

    getSubmissionForm(inspectionId: string): string {
        return `${this.dataCollectorService.baseurl()}/assets/inspection_form/${inspectionId}`;
    }
    getInspectionForms(): string{
        return `${this.dataCollectorService.baseurl()}/assets/inspection_form/master`;
    }

    getProjectUrl(projectUid: string): string {
        return `${this.assetsApiUrls.projectUrl}/${projectUid}`;
    }
}
